export enum PaymentType {
  Dutchiepay = 'dutchiepay',
  Rethink = 'rethink'
}
